import { AxiosError } from 'axios';
import { isCorrectResponse, isConcreteErrorCode } from 'utils/api/error/ResponseError';

interface ExperianError {
  error: string;
}

const isExperianError = (error: AxiosError<any>): error is AxiosError<ExperianError> => {
  if (!isCorrectResponse(error.response)) return false;
  const isCorrectErrorCode =
    isCorrectResponse(error.response) &&
    (isConcreteErrorCode(error.response, '503') || isConcreteErrorCode(error.response, '400'));

  return isCorrectErrorCode && error.response.data.error;
};

export default isExperianError;
